// Metadane aplikacji Klindro — jedno źródło prawdy dla stopki
// (nazwa, wersja, data aktualizacji, prawa autorskie). Aktualizuj przy każdym
// wydaniu (rytuał /koniec-na-dzis); konwencja semver opisana w DZIENNIK.md.
export const APP_INFO = {
  name: "Klindro",
  version: "1.5.0",
  updatedAt: "2026-08-30",
  copyright: "© Banaszczyk Software",
} as const;
